import { useCallback } from 'react';
import { useLocalStorage } from 'usehooks-ts';

import { Possibly } from '../../../types';
import { PreSessionPromptVariant } from './PreSessionPrompt';
import { VariantComponents } from './PreSessionPromptWrapper';

function isSupportedPreSessionPromptVariant(
  variant: Possibly<PreSessionPromptVariant>,
): variant is PreSessionPromptVariant {
  return !!variant && String(variant) in VariantComponents;
}
export function usePreSessionPromptState() {
  const [preSessionPrompt, setPreSessionPrompt] = useLocalStorage<Possibly<PreSessionPromptVariant> | undefined>(
    'preSessionPrompt',
    undefined,
  );

  const clearPreSessionPrompt = useCallback(() => {
    setPreSessionPrompt(undefined);
  }, [setPreSessionPrompt]);

  let validPreSessionPrompt: PreSessionPromptVariant | undefined;

  if (isSupportedPreSessionPromptVariant(preSessionPrompt)) {
    validPreSessionPrompt = preSessionPrompt;
  } else {
    validPreSessionPrompt = undefined;
  }

  return {
    preSessionPrompt: validPreSessionPrompt,
    setPreSessionPrompt,
    rawPreSessionPrompt: preSessionPrompt,
    clearPreSessionPrompt,
  };
}
